import {
  InputCheckboxListOption,
} from '../../../../../../types/interfaces/input.interface';
import { ColumnStepBase } from './column-step-base';

export class ColumnStepLog extends ColumnStepBase {
  column: InputCheckboxListOption[] = [
    {value: 'username', label: 'common.fields.username', isTranslated: true},
    {value: 'action', label: 'common.fields.action', isTranslated: true},
    {value: 'target', label: 'common.fields.traget-group', isTranslated: true},
    {value: 'target_id', label: 'common.fields.target', isTranslated: true},
    {value: 'old_value', label: 'common.fields.old-data', isTranslated: true},
    {value: 'new_value', label: 'common.fields.new-data', isTranslated: true},
    {value: 'route', label: 'common.fields.route', isTranslated: true},
    {value: 'description', label: 'common.fields.description', isTranslated: true},
    {value: 'created_at', label: 'common.fields.created-at', isTranslated: true},
  ];

  constructor() {
    super([
      'username',
      'action',
      'target',
      'target_id',
      'route',
      'description',
      'created_at',
    ]);
  }
}
